import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertImmediateTopUp = (immediateTopups) => {
  let convertedImmediateTopUps = [];

  if (!immediateTopups) return [];

  immediateTopups.forEach((immediateTopup, index) => {
    convertedImmediateTopUps.push({
      key: index + 1,
      ID: immediateTopup.id,
      dateTime: formatDate(immediateTopup.date_time) || "-",
      outletName: immediateTopup.outlet_name || "-",
      officerName: immediateTopup.officer_name || "-",
      topupType: immediateTopup.top_up_type || "-",
      amount: `Rp ${CurrencyFormat(immediateTopup.amount) || 0}`,
      remainingAmount: `Rp ${
        CurrencyFormat(immediateTopup.remaining_balance) || 0
      }`,
      description: immediateTopup.description || "-",
      state: immediateTopup.state,
    });
  });
  return convertedImmediateTopUps;
};
